import {
  dateTimeFormatter,
  tooltipFormatter,
} from '../../../utils/formatters';

const telemetryValueFormatter = value => (
  value === null || typeof value === 'undefined' || value === '' ? 'Нет данных' : value
);

export const telemetryColumns = [
  {
    dataField: 'device_id',
    text: 'device_id',
    disableSort: true,
    headerClassName: 'mv-150',
    formatter: tooltipFormatter,
  },
  {
    dataField: 'timestamp',
    text: 'Дата',
    disableSort: true,
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'gps',
    text: 'Широта',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.lat),
  },
  {
    dataField: 'gps',
    text: 'Долгота',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.lng),
  },
  {
    dataField: 'gps',
    text: 'Высота',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.altitude),
  },
  {
    dataField: 'gps',
    text: 'Градусы',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.heading),
  },
  {
    dataField: 'gps',
    text: 'Скорость',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.speed),
  },
  {
    dataField: 'gps',
    text: 'Гор. точность',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.accuracy),
  },
  {
    dataField: 'gps',
    text: 'Точность GPS/GNSS',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.hdop),
  },
  {
    dataField: 'gps',
    text: 'Кол. спутников',
    disableSort: true,
    formatter: t => telemetryValueFormatter(t?.satellites),
  },
  {
    dataField: 'charge',
    text: 'Зарядка',
    disableSort: true,
    formatter: telemetryValueFormatter,
  },
  {
    dataField: 'stop_id',
    text: 'Остановка',
    disableSort: true,
    formatter: telemetryValueFormatter,
  },
];

export const telemetryAdditionalColumns = [];
